import type { ReactNode } from "react";

interface Props {
  eyebrow?: string;
  title: string;
  desc?: string;
  action?: ReactNode;
  align?: "left" | "center";
}

export default function SectionHeading({ eyebrow, title, desc, action, align = "left" }: Props) {
  return (
    <div
      className={`mb-6 md:mb-8 flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between ${
        align === "center" ? "text-center" : ""
      }`}
    >
      <div className={align === "center" ? "mx-auto" : ""}>
        {eyebrow && (
          <span className="inline-flex items-center gap-1.5 rounded-full bg-secondary-100 px-3 py-1 text-xs font-semibold text-secondary-900">
            <i className="ri-flashlight-fill text-primary-500" />
            {eyebrow}
          </span>
        )}
        <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">{title}</h2>
        {desc && <p className="mt-2 text-sm text-foreground-600 md:text-base">{desc}</p>}
      </div>
      {action}
    </div>
  );
}